import { observer } from 'mobx-react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import Page from 'components/Page';
import store from 'store';

import StudyRules from '@common/components/StudyRules';
import { ROUTES } from '@common/constants/CampusRoutes';

function StudyRulesPage() {
	if (!store.profile.isCreditsTisStudentView) {
		return <Navigate to={ROUTES.PROGRAMS} replace />;
	}

	return (
		<Page title="Study Rules" type="list">
			<StudyRules />
		</Page>
	);
}

export default observer(StudyRulesPage);
